import React from "react";
import { ApiHelper, PlaylistInterface, ManualPlaylistInterface, ArrayHelper, ScreenInterface } from "../../helpers";
import { FormControl } from "react-bootstrap";
import { Loading } from "../../components";

interface Props {
  screen: ScreenInterface,
  saveCallback: () => void,
  pendingCommand: { action: string, parameter: string }
}

export const ManualPlaylists: React.FC<Props> = props => {

  const [manualPlaylists, setManualPlaylists] = React.useState<ManualPlaylistInterface[]>(null);
  const [availablePlaylists, setAvailablePlaylists] = React.useState<PlaylistInterface[]>(null);
  const [deleteIds, setDeleteIds] = React.useState<number[]>([]);


  const init = () => {
    setManualPlaylists(null);
    loadData()
  }

  const loadData = async () => {
    ApiHelper.get("/playlists/available").then((data: PlaylistInterface[]) => {
      const screenShape = (props.screen?.rotation === 90 || props.screen?.rotation === 270) ? "9:16" : "16:9"
      const result: PlaylistInterface[] = []
      data.forEach(d => {
        if (d.shape === screenShape) result.push(d);
      })
      setAvailablePlaylists(result);
    });
    if (props.screen?.id > 0) {
      const data: ManualPlaylistInterface[] = await ApiHelper.get("/manualPlaylists/screen/" + props.screen.id);
      if (data.length > 0) {
        const playlistIds = ArrayHelper.getIds(data, "playlistId");
        const playlists = await ApiHelper.get("/playlists?ids=" + playlistIds.join(","));
        for (let sp of data) sp.playlist = ArrayHelper.getOne(playlists, "id", sp.playlistId);
      }
      setManualPlaylists(data);
    }
  }


  const handleDelete = (index: number) => {
    const mp = manualPlaylists[index];

    if (mp.id && deleteIds.indexOf(mp.id) === -1) {
      let deleteIdsCopy: number[] = [...deleteIds];
      deleteIdsCopy.push(mp.id)
      setDeleteIds(deleteIdsCopy);
    }

    let manualPlaylistsCopy: ManualPlaylistInterface[] = [...manualPlaylists];
    manualPlaylistsCopy.splice(index, 1);
    setManualPlaylists(manualPlaylistsCopy);
  }


  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index: number) => {
    let manualPlaylistsCopy: ManualPlaylistInterface[] = [...manualPlaylists];
    let mp = manualPlaylistsCopy[index];
    let val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "playlist": mp.playlistId = parseInt(val, 0); break;
    }
    setManualPlaylists(manualPlaylistsCopy);
  }

  const getRows = () => {
    const result: JSX.Element[] = [];
    const options: JSX.Element[] = [];
    availablePlaylists?.forEach(ap => { options.push(<option key={"ap_" + ap.id} value={ap.id}>{ap.name}</option>) })

    let idx = 0;
    manualPlaylists?.forEach(mp => {
      const index = idx;
      const changeFunction = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => { handleChange(e, index); }
      result.push(<tr>
        <td><FormControl id="playlist" as="select" size="sm" value={mp.playlistId} onChange={changeFunction}>{options}</FormControl></td>
        <td style={{ whiteSpace: "nowrap" }}>
          <a href="about:blank" className="text-danger" onClick={(e: React.MouseEvent) => { e.preventDefault(); handleDelete(index) }}><i className="fas fa-trash-alt"></i> Delete</a>
        </td>
      </tr>);
      idx++;
    });
    return result;
  }

  const addRow = (e: React.MouseEvent) => {
    e.preventDefault();
    const data = [...manualPlaylists];
    const item: ManualPlaylistInterface = { id: 0 }
    if (availablePlaylists?.length > 0) item.playlistId = availablePlaylists[0].id;
    data.push(item)
    setManualPlaylists(data);
  }


  const handleSave = (screenId: number) => {
    manualPlaylists?.forEach(mp => mp.screenId = screenId);
    const promises: Promise<any>[] = []
    deleteIds?.forEach(id => { promises.push(ApiHelper.delete("/manualPlaylists/" + id)) });
    if (manualPlaylists?.length > 0) promises.push(ApiHelper.post("/manualPlaylists", manualPlaylists));
    Promise.all(promises).then(() => { props.saveCallback() });
  }

  const handleParentCommand = () => {
    if (props.pendingCommand) {
      if (props.pendingCommand.action === "save") handleSave(parseInt(props.pendingCommand.parameter, 0))
    }
  }

  React.useEffect(init, [props.screen.id]);  //eslint-disable-line
  React.useEffect(handleParentCommand, [props.pendingCommand]); //eslint-disable-line



  if (manualPlaylists === null) return <Loading />
  else return (
    <>
      <div className="section">Manual Playlists</div>
      <table className="table table-sm">
        <thead>
          <tr><th>Playlist</th><th>Action</th></tr>
        </thead>
        <tbody>
          {getRows()}
          <tr>
            <td></td>
            <td><a href="about:blank" className="text-success" onClick={addRow}><i className="fas fa-plus"></i> Add</a></td>
          </tr>
        </tbody>
      </table>
    </>
  );
};